/**
 * 3D "push" on hover for any element marked data-tilt (review cards, service cards). The card tilts away
 * from the pointer, as if the pointer presses that spot down, and lifts toward the viewer with a deeper
 * shadow; a soft glare follows the pointer. The element's own CSS reads --tilt-x, --tilt-y, --glare-x and
 * --glare-y and the .is-tilting class. Mouse only; skipped for touch and reduced-motion users.
 */
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const MAX_TILT = 7; // degrees at the very edge of the card

  document.querySelectorAll('[data-tilt]').forEach((card) => {
    card.addEventListener('pointermove', (event) => {
      const r = card.getBoundingClientRect();
      const px = (event.clientX - r.left) / r.width;
      const py = (event.clientY - r.top) / r.height;
      card.style.setProperty('--tilt-x', `${((0.5 - py) * 2 * MAX_TILT).toFixed(2)}deg`);
      card.style.setProperty('--tilt-y', `${((px - 0.5) * 2 * MAX_TILT).toFixed(2)}deg`);
      card.style.setProperty('--glare-x', `${(px * 100).toFixed(1)}%`);
      card.style.setProperty('--glare-y', `${(py * 100).toFixed(1)}%`);
      card.classList.add('is-tilting');
    });
    const reset = () => {
      card.classList.remove('is-tilting');
      card.style.removeProperty('--tilt-x');
      card.style.removeProperty('--tilt-y');
    };
    card.addEventListener('pointerleave', reset);
    card.addEventListener('mouseleave', reset);
  });
})();
